export const COMMUNITY_APPROVE_ME = "COMMUNITY_APPROVE_ME"
export const COMMUNITY_APPROVE_ME_SUCCESS = "COMMUNITY_APPROVE_ME_SUCCESS"
